<template>
<div>
  <p>The API is unreachable.... <a href="#" v-on:click="reload">Reload Page</a></p>
</div>
</template>

<script src="./offline.js"></script>
